import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import * as GmapVue from 'gmap-vue'
import VueLinkPre from 'vue-link-pre'
import Notifications from 'vue-notification'
import vuetify from './plugins/vuetify'

Vue.use(Notifications)
Vue.config.productionTip = false

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyC-Q4KDP0F70ivDjD3VIv4iM_zjsjRERfY',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    /// / If you want to set the version, you can do so:
    // v: '3.40.11',
    region: 'CL',
    language: 'es'
  }

  /// / If you intend to programmatically custom event listener code
  /// / (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  /// / instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  /// / you might need to turn this on.
  // autobindAllEvents: false,

  /// / If you want to manually install components, e.g.
  /// / import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  /// / Vue.component('GmapMarker', GmapMarker)
  /// / then disable the following:
  // installComponents: true,
})

Vue.use(VueLinkPre)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
